<template lang="html">
  <tr class="vcv-table-row">
    <td class="column-checkbox">
      <input type="checkbox" class="checkbox" v-model="selected" :id="'response' + model.id"/>
      <label :for="'response' + model.id"></label>
    </td>

    <td class="column-candidate">
      <router-link tag="div" class="candidate-name" :to="showRoute">
        <a class="candidate-name">{{ candidate.surname }} {{ candidate.name }}</a>
      </router-link>

      <div class="candidate-position">
        <span>{{ vacancy.name }}</span>
      </div>
    </td>

    <td class="column-status">
      <div v-if="status" class="candidate-info-item">
        <span class="candidate-info-item__inner">{{ status }}</span>
      </div>
    </td>

    <td class="column-rating">
      <div class="stars">
        <span v-for="i in [...new Array(stars)]" class="star">
          <i class="fa fa-star"></i>
        </span>
      </div>
    </td>

    <td class="column-already-worked">
      {{ process && process.already_worked ? $tr('responses.resume.yes') : $tr('responses.resume.no') }}
    </td>

    <td class="column-cv">
      <CVLink v-if="process && process.cv_link" :link="process.cv_link" />
    </td>

    <td class="column-date">
      {{ createdAt }}
    </td>

    <td class="column-phone">
      {{ candidate.phone }}
    </td>

    <td class="column-email">
      {{ candidate.email }}
    </td>


    <!-- <td class="column-comments">
      <span v-if="lastComment && !commentMode"> {{ lastCommentMessage }} </span>
      <textarea v-else
        type="text"
        ref="commentInput"
        class="form-control vcv-input comment-text"
        :placeholder="$tr('responses.leaveComment')"
        @blur="leaveComment"
      ></textarea>
    </td> -->

    <!-- <td class="column-actions">
      <div class="comment-pencil" @click="enterCommentMode">
        <i class="icon-edit"></i>
      </div>
    </td> -->
  </tr>
</template>

<script>
  import Moment from 'moment'
  import CVLink from '@/components/shared/CVLink.vue'

  export default {
    name: 'responses-row',

    components: {
      CVLink
    },

    props: {
      model: Object
    },

    methods: {
      allowSelect () {
        const isSelectionMode = getSelection().toString().length > 0

        if (!isSelectionMode) {
          this.routeToCard()
        }
      },

      routeToCard () {
        if (this.showRoute) {
          this.$router.push(this.showRoute)
        }
      },

      enterCommentMode () {
        this.commentMode = true
        setTimeout(_ => this.$refs.commentInput.focus(), 50)
      },

      leaveComment (event) {
        const message = event.target.value
        if (message.length > 0) {
          this.$store
            .dispatch('response/createComment', {id: this.model.id, message: event.target.value})
            .then(() => this.$store.dispatch('responses/fetch'))
          this.presendComment = event.target.value
        }
        this.commentMode = false
      }
    },

    data () {
      return {
        commentMode: false,
        presendComment: ''
      }
    },

    computed: {
      process () {
        return this.model['bat-personal-account']
      },

      showRoute () {
        return {
          path: `/responses/${this.model.id}`
        }
      },

      selected: {
        get () {
          return this.$store.getters['responses/isSelected'](this.model)
        },

        set (val) {
          this.$store.commit('responses/select', {
            model: this.model,
            value: val
          })
        }
      },

      status () {
        const key = `responses.filtersOptions.statuses.byId.${this.model.status.id}`
        return this.$tr(key) === key ? this.model.status.name : this.$tr(key)
      },

      candidate () {
        return this.model.candidate
      },

      vacancy () {
        return this.model.vacancy
      },

      source () {
        return this.model.source
      },

      stars () {
        return this.model.star ? this.model.star.value : 0
      },

      createdAt () {
        return this.model.created_at
          ? Moment(this.model.created_at).format('DD.MM.YYYY HH:mm')
          : null
      },

      lastComment () {
        return this.presendComment
          ? {message: this.presendComment}
          : this.model.comments[0]
      },

      lastCommentMessage () {
        return this.lastComment.message.length > 50
          ? `${this.lastComment.message.slice(0, 50)}...`
          : this.lastComment.message
      }
    },

    beforeMount () {}
  }
</script>

<style lang="scss" scoped>
  @import '@/styles/colors.scss';
  @import '@/styles/variables.scss';

  .candidate-info-item {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
    display: flex;
    flex-flow: column;
  }

  .vcv-table .vcv-table-row {
    height: 80px;
  }

  .column-checkbox {
    label {
      margin: 0;
    }
  }

  .avatar-holder {
    width: 84px;
    height: 64px;
    background-color: #f0f0f0;
    position: relative;
    cursor: pointer;
    margin: 0 auto;

    img {
      display: none;
      max-height: 100%;
      max-width: 100%;
      width: auto;
      height: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
  }

  .audio-holder {
    position: relative;
    width: 84px;
    background-color: white;
  }

  .candidate-name {
    font-size: 16px;
    color: $green;
    display: block;
  }

  .candidate-position {
    font-size: 16px;
  }

  .comment-text {
    resize: vertical;
    border-color: lightgray;
    padding-left: 2px;
  }

  .comment-text:not(:focus) {
    border: none;
    box-shadow: none;
    resize: none;
  }

  .comment-pencil {
    cursor: pointer;
  }

  .column-comments {
    word-wrap: break-word;
    font-style: italic;
  }

  .column-rating {
    .star {
      color: #fec500;
      font-size: 16px;
      margin-right: 5px;
    }
  }
</style>
